// v2.24 "Rekap pcs" (owner 2026-11-03): pieces IN / FINISHED per station, today or this month,
// columns Atasan / Celana / Kaos; a barang without a kind = "Belum ditentukan". Pure helpers
// (no imports) so Jest can test them; the numbers themselves come from the server.

export const KOLOM = [["atasan", "Atasan"], ["celana", "Celana"], ["kaos", "Kaos"]];
export const KOLOM_SINGKAT = { atasan: "A", celana: "C", kaos: "K", belum: "?" };
// choices of the master field (menu Barang); "" = not filled in yet
export const JENIS = [["", "Belum ditentukan"], ["ATASAN", "Atasan"], ["CELANA", "Celana"],
  ["STELAN", "Stelan (1 atasan + 1 celana)"], ["KAOS", "Kaos"], ["TIDAK_DIHITUNG", "Tidak dihitung"]];
export const PERIODE = [["hari", "Hari ini"], ["bulan", "Bulan ini"]];
export const STATUS_TEKS = { MENUNGGU: "menunggu", SEDANG: "sedang dikerjakan", SEBAGIAN: "sebagian selesai", SELESAI: "selesai" };
const JENIS_LABEL = Object.fromEntries(JENIS);

export const n0 = (v) => (Number.isFinite(Number(v)) ? Number(v) : 0);
export function labelJenis(kode) { return JENIS_LABEL[kode || ""] || JENIS_LABEL[""]; }

// "termasuk 2 reject" — empty when there is nothing to say
export function termasuk(n, kata) { return n0(n) > 0 ? `termasuk ${n0(n)} ${kata}` : ""; }

// "20 pcs" of one column, or "—" when none
export function pcsTeks(kol, kunci) { const n = n0((kol || {})[kunci]); return n ? `${n} pcs` : "—"; }

// compact "A 20 · C 20 · ? 3" for a table cell (only the columns that have pieces)
export function kolomRingkas(kol) {
  const isi = ["atasan", "celana", "kaos", "belum"].filter((k) => n0((kol || {})[k]) > 0);
  return isi.map((k) => `${KOLOM_SINGKAT[k]} ${n0(kol[k])}`).join(" · ");
}

// is there anything to show for a station (either period)?
export function adaIsi(p) {
  return ["atasan", "celana", "kaos", "belum"].some((k) => n0(p?.masuk?.[k]) > 0 || n0(p?.selesai?.[k]) > 0);
}

// "Belum ditentukan: masuk 10 pcs · selesai 4 pcs (2 barang)" — empty when every barang has a kind
export function belumTeks(belum) {
  const m = n0(belum?.masuk), s = n0(belum?.selesai), b = (belum?.barang || []).length;
  if (!m && !s && !b) return "";
  const bag = [];
  if (m) bag.push(`masuk ${m} pcs`);
  if (s) bag.push(`selesai ${s} pcs`);
  return `Belum ditentukan: ${bag.join(" · ") || "0 pcs"} (${b} barang)`;
}

// the order as the operator reads it: customer · team · "Desain 2 dari 3"
export function pesananTeks(r) {
  const bag = [];
  if (r?.customer) bag.push(r.customer);
  if (r?.tim && r.tim !== r.customer) bag.push(r.tim);
  if (n0(r?.jumlah_desain) > 1) bag.push(`Desain ${r.desain} dari ${r.jumlah_desain}`);
  return bag.join(" · ") || "—";
}

// note of a row: rework round, its source, the status
export function keteranganTeks(r) {
  const bag = [];
  if (r?.rework_ke) bag.push(`rework ke-${r.rework_ke}${r.sumber_rework === "POS" ? " (laporan pos)" : ""}`);
  if (r?.status && r.status !== "SELESAI") bag.push(STATUS_TEKS[r.status] || r.status.toLowerCase());
  return bag.join(" · ");
}

// search by SPK number, nota number, customer or team (any case); station filter for the supervisor
export function saringBaris(rows, { pos = "", cari = "" } = {}) {
  const q = (cari || "").trim().toLowerCase();
  return (rows || []).filter((r) => (!pos || r.pos_code === pos)
    && (!q || [r.nomor_spk, r.nomor_faktur, r.customer, r.tim].some((v) => String(v || "").toLowerCase().includes(q))));
}

// rows of the table: newest first (finished, else entered)
export function urutkanBaris(rows) {
  return [...(rows || [])].sort((a, b) => String(b.selesai_pada || b.masuk_pada || "").localeCompare(String(a.selesai_pada || a.masuk_pada || "")));
}

// sum of the station cards (supervisor: every station in one line)
export function jumlahPos(posList) {
  const out = { masuk: { atasan: 0, celana: 0, kaos: 0, belum: 0, total: 0, rework: 0 },
    selesai: { atasan: 0, celana: 0, kaos: 0, belum: 0, total: 0, rework: 0, reject: 0 } };
  (posList || []).forEach((p) => {
    Object.keys(out.masuk).forEach((k) => { out.masuk[k] += n0(p.masuk?.[k]); });
    Object.keys(out.selesai).forEach((k) => { out.selesai[k] += n0(p.selesai?.[k]); });
  });
  return out;
}
